import * as Actions from './actions.type'
// import * as Mutations from './mutations.type'
import * as Services from './services'

import { IDP } from "./types";

interface State {
  list: IDP[], // список курсов для начальной страницы
  item: IDP | null,  // открытый курс при редактировании в диалоге
  activeIDP: IDP | null, // страница открытого курса
}

const store: State = {
  list: [],
  item: null,
  activeIDP: null,

}

const actions = {
  // [Actions.GET_ADMINS]: Services.getAdmins,
  [Actions.GET_IDP_LIST]: Services.getIDPList, // получение с учетом прав
  [Actions.FINISH_TASK]: Services.finishTask, // завершение задач
}

const mutations = {
  // [Mutations.SET_ADMINS](state: State, admins: string[]) {
  //   state.activeIDP = {admins}
  // }
} 


export default {
  namespaced: true,
  state: store,
  // getters,
  actions,
  mutations,
};